import { queryOptions, useQuery } from '@tanstack/react-query';
import { BeltObservationService, DateRangeDTO } from '../generated';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';

const beltObservationDaysKeys = {
  base: () => ['beltObservationDays'] as const,
  one: ({ jobsiteId, dateRange }: BeltObservationDaysOptionsProps) =>
    [...beltObservationDaysKeys.base(), jobsiteId, dateRange] as const,
};

interface BeltObservationDaysOptionsProps {
  jobsiteId: string | undefined;
  dateRange: DateRangeDTO;
}

function beltObservationDaysOptions({ jobsiteId, dateRange }: BeltObservationDaysOptionsProps) {
  return queryOptions<string[], ApiError>({
    queryKey: beltObservationDaysKeys.one({ jobsiteId, dateRange }),
    queryFn: async () => {
      if (!jobsiteId || !dateRange) throw new Error('jobsiteId and dateRange are required');

      const response = await BeltObservationService.beltControllerGetBeltObservationDays({
        path: { jobsiteId },
        query: { observedAt: dateRange, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
      });

      if (response.data != undefined) {
        return response.data;
      }

      throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
    },
    enabled: !!jobsiteId && !!dateRange,
  });
}

export function useBeltObservationDays(props: BeltObservationDaysOptionsProps) {
  return useQuery(beltObservationDaysOptions(props));
}
